export class ChatApiService {
  constructor(http) {
    this.endpoint = '/chat';
    this.http = http;
  }

  async readFile(file) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = ({ target }) => resolve(target.result);
      reader.readAsDataURL(file);
    });
  };

  async createSessionAndToken(conversationId) {
    return this.http.post(this.endpoint + '/token/', {
      session: {
        mediaMode: 'ROUTED',
        recordingMode: 'MANUAL',
        customSessionId: conversationId,
        defaultOutputMode: 'COMPOSED',
        defaultRecordingLayout: 'BEST_FIT'
      },
      tokenOptions: {
        role: 'PUBLISHER',
        data: ''
      }
    });
  }

  createMessage({ conversationId, text, id }) {
    const body = {
      conversation_id: conversationId,
      text
    };
    if (typeof id !== 'undefined') {
      body.id = id;
    }
    return this.http.post(this.endpoint + '/message/', body);
  }

  sendFiles(conversationId, files) {
    const formData = new FormData();
    formData.append('conversation_id', conversationId);
    files.forEach(({ file }) => {
      formData.append('files', file.targetFile);
    });
    return this.http.post(this.endpoint + '/message/', formData);
  }

  getConversations() {
    return this.http.get(this.endpoint + '/conversation/');
  }

  subscribeWebPush(data) {
    return this.http.post(this.endpoint + '/save-subscription/', data);
  }

  sendInvitePush(data) {
    return this.http.post(this.endpoint + '/invite-conversation/', data);
  }

  async getConversation(id) {
    const { data } = await this.http.get(`${this.endpoint}/conversation/${id}`);
    return data;
  }

  async exitConversation(id, anyparams) {
    const params = {user_only: true, user_id: anyparams ? anyparams : undefined};
    const { data } = await this.http.delete(`${this.endpoint}/conversation/${id}`, params);
    return data;
  }

  async getMessages(conversationId) {
    const { data } = await this.http.get(this.endpoint + '/message/', {
      conversation_id: conversationId
    });
    return data;
  }

  async createPrivateChat(id, name) {
    const { data } = await  this.http.post(this.endpoint + '/conversation/by_timeslot/' + id, {name});
    return data;
  }

  async startRecord(id) {
    const { data } = await this.http.post(this.endpoint + '/' + id + '/call/start/');
    return data;
  }
  async stopRecord(id) {
    const { data } = await this.http.post(this.endpoint + '/' + id + '/call/finish/');
    return data;
  }
  async viewsRecordings(id) {
    const { data } = await this.http.get(this.endpoint + '/' + id + '/call/view/');
    return data;
  }
  
};
